import './photo-album.scss';
import 'magnific-popup';
import AOS from 'aos';

export default () => {
	$( '.popup-gallery' ).magnificPopup( {
		delegate: 'a',
		type: 'image',
		tLoading: 'Loading image #%curr%...',
		mainClass: 'mfp-img-mobile',
		gallery: {
			enabled: true,
			navigateByImgClick: true,
			preload: [
				0,
				1,
			],
		},
	} );

	AOS.init( {
		duration: 800,
		once: true,
	} );
};
